import { render } from "./App.vue?vue&type=template&id=c8acc6f2"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import exportComponent from "C:\\SIMPLEX\\SIMPLEXBT\\SPACS\\SPacs\\SPacs.Appointment.Web\\client-app\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__